export default () => {
	const { location: { href } } = window;
	let env = 'local';

	if (href.includes('-dev'))
		env = 'dev';
	else if (href.includes('dev.'))
		env = 'dev';
	else if (href.includes('-stg'))
		env = 'stg';
	else if (href.includes('stg.'))
		env = 'stg';
	else if (href.includes('-sandbox'))
		env = 'sandbox';
	else if (href.includes('sandbox.'))
		env = 'sandbox';
	else if (href.indexOf('posillicowashplant.com') !== -1)
		env = 'prod';
	else if (href.indexOf('posillico-washplant.netlify') !== -1)
		env = 'prod';

	console.log('env', env);

	return env;
};
